import React from "react"
import { Container, Flex } from "@chakra-ui/react"

import CalloutTile from "@components/CalloutTile/CalloutTile"
import { useRoutes } from "@hooks/useRoutes"
import { useImage } from "@hooks/useImage"

export interface CalloutRowProps {
  callouts?: GatsbyTypes.SanityCallout[]
  spacing?: "large" | "small"
  toggle?: "On" | "Off"
}

const CalloutRow = ({ callouts = [], spacing, toggle }: CalloutRowProps) => {
  const { urlResolver } = useRoutes()
  const { getGatsbyImage } = useImage()

  const items = callouts.map(callout => ({
    key: callout._key,
    image: getGatsbyImage(callout.image),
    link: urlResolver(callout.link),
  }))

  const maxCollections = items.length >= 3
  const paddingTop = spacing === "large" ? (maxCollections ? 4.5 : [2.5, 4.5]) : [2.5, 4.5]
  const paddingBottom = maxCollections ? 4.5 : [2.5, 4.5]

  return (
    <Container>
      <Flex
        direction={["column", "row"]}
        pt={paddingTop}
        pb={paddingBottom}
        columnGap={2}
        rowGap={2.5}
        justifyContent="center"
        alignItems="center"
      >
        {items.map(item => (
          <CalloutTile key={item.key} image={item.image} link={item.link} toggle={toggle} size={maxCollections ? "medium" : "large"} />
        ))}
      </Flex>
    </Container>
  )
}

export default React.memo(CalloutRow)
